import { createApi } from "@reduxjs/toolkit/query/react";
import { endPoints, urlKeys } from "../../api";
import { baseQuery } from "./baseQuery";
import { formatString } from "../../utils/urlFormatting";

const createFormData = (data: any) => {
  const formData = new FormData();
  formData.append("file", data);
  return formData;
};

export const protocolQuery = createApi({
  baseQuery,
  reducerPath: "protocolQueries",
  endpoints: (builder) => ({
    uploadProtocol: builder.mutation<any, any>({
      query: ({ data, study_id, protocol_name }) => ({
        url: `${formatString(endPoints.protocol.upload, {
          key: urlKeys.study_id,
          value: encodeURIComponent(study_id),
        })}?protocol_name=${encodeURIComponent(protocol_name)}`,
        method: "POST",
        body: data ? createFormData(data) : {},
      }),
    }),
    downloadProtocol: builder.query<any, any>({
      query: ({ protocol_uuid }) => ({
        url: `${formatString(endPoints.protocol.download, {
          key: urlKeys.protocol_uuid,
          value: protocol_uuid,
        })}`,
        method: "GET",
        responseHandler: (response) => response.blob(),
      }),
    }),
    getAllProtocols: builder.query<any, any>({
      query: ({ study_id }) => ({
        url: `${formatString(endPoints.protocol.getAll, {
          key: urlKeys.study_id,
          value: encodeURIComponent(study_id),
        })}`,
        method: "GET",
      }),
    }),
    updateProtocol: builder.mutation<any, any>({
      query: ({ data, protocol_uuid, protocol_name }) => ({
        url: `${formatString(endPoints.protocol.update, {
          key: urlKeys.protocol_uuid,
          value: protocol_uuid,
        })}?protocol_name=${encodeURIComponent(protocol_name)}`,
        method: "PUT",
        body: data ? createFormData(data) : {},
      }),
    }),
    deleteProtocol: builder.mutation<any, any>({
      query: ({ protocol_uuid }) => ({
        url: `${formatString(endPoints.protocol.delete, {
          key: urlKeys.protocol_uuid,
          value: protocol_uuid,
        })}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useUploadProtocolMutation,
  useLazyDownloadProtocolQuery,
  useLazyGetAllProtocolsQuery,
  useUpdateProtocolMutation,
  useDeleteProtocolMutation,
} = protocolQuery;
